/* eslint no-unused-vars: 0 */

/* TODO: Pass CSRF Token with all AJAX Requests */

import React from "react"
import AdminSearchLivePreview from "./live_preview"
import AdminSearchPromotions from "./search_promotions"
import AdminSearchInstructions from "./instructions"
import AdminSearchProcessing from "./processing"
import AdminSearchError from "./error"
import AdminSearchTermResults from "./search_term_results"

class AdminSearchBase extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      categories: [],
      create_product_promotion: false,
      display_results: false,
      error: false,
      filter_term: "",
      products: [],
      query_term: "",
      searching: false,
      selected_mode: "",
      selected_promotions: [],
      selected_term: "",
      page: 1,
      view_instructions: true
    };

    this.displayResults = this.displayResults.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleSearchInput = this.handleSearchInput.bind(this);
    this.setSearchTerm = this.setSearchTerm.bind(this);
    this.setSearchStatus = this.setSearchStatus.bind(this);
    this.setErrorStatus = this.setErrorStatus.bind(this);
    this.setFilterTerm = this.setFilterTerm.bind(this);
    this.setPage = this.setPage.bind(this);
    this.getPromotions = this.getPromotions.bind(this);
    this.toggleInstructions = this.toggleInstructions.bind(this);
  }

  setPage(number) {
    this.setState(
      {
        page: number
      },
      () => {
        this.getPromotions();
      }
    );
  }

  setSearchTerm(term, term_type) {
    this.setState(
      {
        selected_mode: term_type,
        selected_term: term,
        view_instructions: false
      },
      () => {
        this.displayResults(false);
        this.getPromotions();
      }
    );
  }

  toggleInstructions() {
    this.setState({
      view_instructions: !this.state.view_instructions
    });
  }

  handleSearchInput(e) {
    this.setState(
      {
        query_term: e.target.value,
        products: [],
        display_results: false
      },
      () => {
        if (e.keyCode === 13) {
          this.handleSearch();
        }
      }
    );
  }

  handleSearch() {
    this.setState({ searching: true, products: [], view_instructions: false });
    $.ajax({
      url: "/admin/site_search/",
      data: { q: this.state.query_term },
      method: "GET",
      dataType: "JSON",
      success: data => {
        this.setState({
          categories: data.results.categories,
          create_category_promotion: false,
          create_product_promotion: data.results.create_product_promotion,
          create_product_promotion_count:
            data.results.create_product_promotion_count,
          create_product_category_promotion:
            data.results.create_product_category_promotion,
          create_product_category_promotion_count:
            data.results.create_product_category_promotion_count,
          display_results: true,
          products: data.results.products,
          searching: false
        });
      },
      error: () => {
        this.setState({
          searching: false,
          error: true
        });
      }
    });
  }

  displayResults(display) {
    this.setState({ display_results: display });
  }

  getPromotions(remove_filter_term = true) {
    var query_url =
      this.state.selected_mode === "Product"
        ? "/admin/site_search/product_search_terms"
        : "/admin/site_search/product_category_search_terms";

    this.setState(
      {
        searching: true,
        filter_term: remove_filter_term === true ? "" : this.state.filter_term
      },
      () => {
        $.ajax({
          url: query_url,
          data: {
            term: this.state.selected_term,
            filter_term: this.state.filter_term,
            page: this.state.page
          },
          method: "GET",
          dataType: "JSON",
          success: data => {
            this.setState({
              searching: false,
              selected_promotions: data.results,
              selected_promotions_total: data.total_results
            });
          },
          error: () => {
            this.setState({ searching: false, error: true });
          }
        });
      }
    );
  }

  setFilterTerm(term) {
    this.setState({ filter_term: term, page: 1 }, () => {
      this.getPromotions(false);
    });
  }

  setSearchStatus(status) {
    this.setState({
      searching: status
    });
  }

  setErrorStatus(status) {
    this.setState({
      error: status
    });
  }

  render() {
    var preview =
      this.state.selected_mode === "Product" ? (
        <AdminSearchLivePreview
          preview_type={"products"}
          results={this.state.selected_promotions}
          term={this.state.selected_term}
        />
      ) : (
        ""
      );

    var results =
      this.state.view_instructions === false ? (
        <AdminSearchPromotions
          getPromotions={this.getPromotions}
          mode={this.state.selected_mode}
          results={this.state.selected_promotions}
          setErrorStatus={this.setErrorStatus}
          setSearchStatus={this.setSearchStatus}
          set_filter_term={this.setFilterTerm}
          term={this.state.selected_term}
          filter_term={this.state.filter_term}
          total_results={this.state.selected_promotions_total}
          selected_mode={this.state.selected_mode}
          setPage={this.setPage}
          page={this.state.page}
        />
      ) : (
        <AdminSearchInstructions
          recently_updated_products={this.props.recently_updated_products}
          recently_updated_product_categories={
            this.props.recently_updated_product_categories
          }
          setSearchTerm={this.setSearchTerm}
        />
      );

    return (
      <div className="promoted--site-search">
        <AdminSearchProcessing searching={this.state.searching} />
        <AdminSearchError display={this.state.error} />
        <div className="main--search">
          <input
            onKeyUp={e => {
              e.persist();
              this.handleSearchInput(e);
            }}
            onPaste={e => {
              e.persist();
              this.handleSearchInput(e);
            }}
            onChange={e => {
              e.persist();
              this.handleSearchInput(e);
            }}
            onInput={e => {
              e.persist();
              this.handleSearchInput(e);
            }}
            placeholder="Search or Add Terms"
            spellCheck="false"
            type="text"
          />
          <button onClick={this.handleSearch}>
            <i className="icon-search" />
          </button>
        </div>
        <button
          className="btn toggle-instructions"
          onClick={this.toggleInstructions}
        >
          Toggle Instructions / Recent Terms
        </button>
        <AdminSearchTermResults
          create_product_category_promotion={
            this.state.create_product_category_promotion
          }
          create_product_category_promotion_count={
            this.state.create_product_category_promotion_count
          }
          create_product_promotion={this.state.create_product_promotion}
          create_product_promotion_count={
            this.state.create_product_promotion_count
          }
          displayResults={this.state.display_results}
          query_term={this.state.query_term}
          results={this.state.products.concat(this.state.categories)}
          setSearchTerm={this.setSearchTerm}
        />

        {results}

        {preview}
      </div>
    );
  }
}

export default AdminSearchBase;
